import React, { useEffect, useState } from "react";
import "./style.scss";
import useApiPost from "../../Hooks/usePost";
import { useNavigate, useLocation } from "react-router-dom";
import Storelist from "../../Store/Actions";
import { Logo } from "../../appconfig";
import { toast } from "react-toastify";
import { setLoader } from "../../Store/Actions/page";
import { BASE_URL_API, BASE_URL_API2 } from "../../appconfig";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { convertToData } from "lightgallery/lg-utils";

const ForgotPassword = () => {
  const [isPassword, setIsPassword] = useState(true);
  const [isConfirmPassword, setIsConfirmPassword] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordSame, setPasswordSame] = useState(false);
  const { setLoading } = Storelist();
  const resetPassword = useApiPost();
  const Navigate = useNavigate();

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const token = query.get("rpt"); 

  //   console.log("Reset Token:", token);

  const FormSubmitHandler = (e) => {
    e.preventDefault();
    let data = new FormData(e.target);

    console.log(data.get("password"));
    console.log(data.get("confirmPassword"));
    if(data.get("password") !== data.get("confirmPassword")){
         toast.warn("Password and Confirm Password should be same", { position: "top-center" });
         return
    }
    if(data.get("password").length < 8){
         toast.warn("Password should be minimum 8 characters", { position: "top-center" });
         return
    }
    setLoading(true);
    resetPassword.Postdata(`${BASE_URL_API()}resetpassword?rpt=${token}`, false, {
      password: data.get("password"),
    });
  };

  useEffect(() => {
    if (resetPassword.data !== null) {
      if (resetPassword.data?.status === 200) {
        toast.success("Password changed successfully", {
          position: "top-center",
          onClose: () => {
            Navigate("/login", { replace: true });
          },
        })
      }
    } else if (resetPassword.error !== null) {
      console.log(resetPassword.error);
      toast.error(resetPassword?.error?.body?.message, {
        position: "top-center",
      });
    }
    resetPassword.setData(null);
    resetPassword.setError(null);
    setLoading(false);
  }, [resetPassword?.data, resetPassword?.error]);

  const confirmPasswordCheck = (e) => {
    console.log(e.target.value);
    console.log(e.target.name);

    if (e.target.name === "confirmPassword") {
      setConfirmPassword(e.target.value);
      if (e.target.value !== password) {
        setPasswordSame(true);
      } else {
        setPasswordSame(false);
      }
    } else if (e.target.name === "password") {
      setPassword(e.target.value);
      if (e.target.value !== confirmPassword) {
        setPasswordSame(true);
      } else {
        setPasswordSame(false);
      }
    }
  };

  return (
    <>
      <div className="login-container">
        <div className="login-input-wrapper">
          <div className="login-header">
            <img src={Logo} alt="Logo" />
            <button className="invisible">
              <i className="fa-solid fa-location-dot"></i>
              <span>Velachery</span>
            </button>
          </div>

          <form action="" onSubmit={FormSubmitHandler} className="relative">
            <input
              type={isPassword ? "password" : "text"}
              name="password"
              id="email"
              placeholder="password"
              required
              minLength={8}
              onChange={confirmPasswordCheck}
            />
            <span className="absolute top-5 right-3">
              {isPassword ? (
                <FaEyeSlash
                  onClick={() => {
                    setIsPassword(!isPassword);
                  }}
                />
              ) : (
                <FaEye
                  onClick={() => {
                    setIsPassword(!isPassword);
                  }}
                />
              )}
            </span>
            <input
              type={isConfirmPassword ? "password" : "text"}
              name="confirmPassword"
              id="password"
              placeholder=" confirm Password"
              required
              minLength={8}
              onChange={confirmPasswordCheck}
            />
            <p>
              {passwordSame && (
                <span className="text-red-700">Password does not match</span>
              )}
            </p>
            <span className="absolute top-19 right-3">
              {isConfirmPassword ? (
                <FaEyeSlash
                  onClick={() => {
                    setIsConfirmPassword(!isConfirmPassword);
                  }}
                />
              ) : (
                <FaEye
                  onClick={() => {
                    setIsConfirmPassword(!isConfirmPassword);
                  }}
                />
              )}
            </span>

            <div className="btn-container justify-center">
              {/* <button type="button">Forgot Password?</button> */}
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
